import { Card, CardBody, SimpleGrid, Text } from '@chakra-ui/react'
import { Link as RouterLink } from 'react-router-dom'
import DashboardSection from './DashboardSection'

const REPORT_QUICK_LINKS = [
  { label: 'SLA Compliance', to: '/reports/sla-compliance', desc: 'Met vs breached' },
  { label: 'Agent Performance', to: '/reports/agent-performance', desc: 'Full leaderboard' },
  { label: 'Ticket Productivity', to: '/reports/ticket-productivity', desc: 'Handling · daily · monthly' },
  { label: 'SD Agent Productivity', to: '/reports/agent-productivity', desc: 'RAW FD/FP workbook' },
  { label: 'Task Reports', to: '/reports/task-reports', desc: 'Open, overdue & completion' },
  { label: 'FE Attendance', to: '/reports/fe-attendance', desc: 'Field punch compliance' },
]

export default function ReportQuickLinks() {
  return (
    <DashboardSection title="Reports" actionLabel="All reports ↗" actionTo="/reports/overview">
      <SimpleGrid columns={{ base: 2, sm: 3, lg: 6 }} spacing={2}>
        {REPORT_QUICK_LINKS.map((r) => (
          <Card key={r.to} as={RouterLink} to={r.to} _hover={{ boxShadow: 'md' }} bg="white" size="sm">
            <CardBody py={2.5} px={3}>
              <Text fontWeight="semibold" fontSize="sm" color="blue.700" noOfLines={1}>
                {r.label}
              </Text>
              <Text fontSize="xs" color="gray.500" noOfLines={1}>
                {r.desc}
              </Text>
            </CardBody>
          </Card>
        ))}
      </SimpleGrid>
    </DashboardSection>
  )
}
